module.controller('inActiveCtrl', ['$scope', '$state', '$idle', 
  function ($scope, $state, $idle) {
    $scope.events = [];
    $scope.inActiveState = false;
    $scope.countdown = 15;

    $scope.$on('$idleStart', function () {
      $scope.inActiveState = true;
    });

    $scope.$on('$idleWarn', function(e, countdown) {
      $scope.countdown = countdown;
    });

    $scope.$on('$idleTimeout', function () {
      $state.go('logout');
    });
  }]);
